<template>
  <div
    :class="[
      $style.base,
      {
        [$style.reverseBg]: reverseBg,
        [$style.padding]: padding,
        [$style.smallScreen]: $screen === 's',
        [$style.mediumScreen]: $screen === 'm'
      }
    ]"
  >
    <div :class="$style.containerHeading">
      <BaseText
        bold
        color="inverted"
      >
        {{ heading }}
      </BaseText>
    </div>
    <div :class="$style.slotContainer">
      <slot />
    </div>
    <div :class="$style.description">
      <BaseText
        bold
        mb
        center
      >
        {{ title }}
      </BaseText>
      <BaseText center>{{ description }}</BaseText>
    </div>
  </div>
</template>
<script
  setup
  lang="ts"
>
defineProps<{
  heading: string;
  title: string;
  description: string;
  reverseBg?: boolean;
  padding?: boolean;
}>();
</script>

<style
  lang="scss"
  module
>
.base {
  border-radius: $radius;
  flex-basis: 30%;
  padding: 0 $spacing;
  margin-bottom: $spacing * 2;

  &.smallScreen,
  &.mediumScreen {
    width: 100%;
  }
  &.mediumScreen {
    flex-basis: 48%;
  }
  &.smallScreen {
    flex-basis: 100%;
  }
}

.containerHeading {
  background: linear-gradient(96deg, var(--color-primary) -15.75%, #ffd8df 196.48%);
  border-radius: $radius $radius 0px 0px;
  height: 30px;
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;

  .reverseBg & {
    background: linear-gradient(275deg, var(--color-primary) 23.68%, #ffd8df 128.08%);
  }
}

.description {
  width: 100%;
  padding: $spacing;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  border: 1px solid var(--color-border);
  border-top: 0px;
  margin-top: -5px;
  border-radius: 0px 0px $radius $radius;

  .padding & {
    height: 163px;
  }
}

.slotContainer {
  display: flex;
  align-items: center;
  justify-content: center;

  border: 1px solid var(--color-border);
  border-bottom: 0px;
  border-top: 0px;
}
</style>
